<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header">
    <div class="modal-title">Campaign Management</div>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="close(dialog, false)">
      <span aria-hidden="true">×</span>
    </button>
  </div>  
  <div class="modal-body">
    <iframe style="border-radius: 8px;" width="100%" height="500" src="https://www.youtube.com/embed/j5lDgEIB08U" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  </div> 
</ng-container>